import { Component, ChangeDetectorRef , AfterViewChecked, OnInit  } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LinhaService } from 'src/app/providers/linha.service';

@Component({
  selector: 'app-horarios',
  templateUrl: './horarios.component.html',
  styleUrls: ['./horarios.component.scss']
})
export class HorariosComponent implements OnInit {

  linhaCurrent  = new Object();
  currentHour = 0;
  horarios = [];
  selected: number;

  constructor(
    private router: ActivatedRoute,
    private linhas: LinhaService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {


    this.router.params.subscribe(res => {

      this.selected = res['id'];

      this.linhas.getLinhaById(this.selected)
      .subscribe(res => {

        const obj_linha = res;
        this.loadingLinha(obj_linha);

      });

    });

    this.cdr.detectChanges();

  }

  loadingLinha(linha) {

    this.selected = linha['id'];
    this.linhaCurrent = linha;

  }

}
